import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Art from "./Art";
import Home from "./Home";
import NavBar from "./NavBar";
import Experiences from "./Experiences";
import Photography from "./Photography";
import Projects from "./Projects";
import CountryGallery from './components/CountryGallery';
import { flights } from "./flags";
import "./styles/App.css";

// Import gallery images for preloading
import covid from "./assets/myWork/social_commentary/covid.png";
import metoo from "./assets/myWork/social_commentary/metoo.png";
import prize from "./assets/myWork/social_commentary/prize.png";
import teeth1 from "./assets/myWork/teeth/Diana 牙齿组一220190330.jpg";
import teeth2 from "./assets/myWork/teeth/Diana 牙齿组二2 20190330.jpg";
import teeth3 from "./assets/myWork/teeth/Diana牙齿组三 20190330.jpg";
import fight from "./assets/myWork/teeth/fight.png";
import man from "./assets/myWork/teeth/man.png";
import corn from "./assets/myWork/travels/corn.png";
import diana1 from "./assets/myWork/travels/Diana20190616.jpg";
import diana2 from "./assets/myWork/travels/Diana20190619.jpg";
import grandparents from "./assets/myWork/travels/grandparents.png";
import kids from "./assets/myWork/travels/kids.png";
import twoGirls from "./assets/myWork/travels/two girls 2.png";
import parents from "./assets/myWork/travels/parents.JPG";

// The Oct 2026 design is served as static pages at "/", "/paintings" and "/photos"
// (see scripts/oct2026-postbuild.js and vercel.json); this React app handles every
// other address. If the app itself navigates to "/" with the flight on, load the
// real home page instead of the old Home component.
// Full page load of the static home page. Guarded so that if the server ever
// serves this app at "/" (e.g. the postbuild step didn't run) it shows the old
// Home instead of reloading forever.
function GoHome() {
  const [fallback, setFallback] = React.useState(false);
  useEffect(() => {
    let tried = false;
    try {
      // only a reload within the last few seconds counts as a loop
      tried = Date.now() - Number(sessionStorage.getItem("oct2026:goHome") || 0) < 4000;
      sessionStorage.setItem("oct2026:goHome", String(Date.now()));
    } catch {
      tried = false;
    }
    if (tried && window.location.pathname === "/") setFallback(true);
    else window.location.replace("/");
  }, []);
  return fallback ? <Home /> : null;
}

// With the flight on, the site only has "/", "/paintings" and "/photos"
// ("/pennings" and "/prototypes" are coming soon), so old addresses go to
// their replacement in the new design.
function newDesignAddress(pathname) {
  const path = pathname.toLowerCase();
  if (path === "/art") return "/paintings";
  if (path === "/photography" || path.startsWith("/photography/")) return "/photos";
  return "/";
}

function GoTo({ href }) {
  useEffect(() => {
    window.location.replace(href);
  }, [href]);
  return null;
}

function AppRoutes() {
  const { pathname } = useLocation();
  const oct2026 = flights.enableOct2026Design;

  if (oct2026 && pathname !== "/") {
    return <GoTo href={newDesignAddress(pathname)} />;
  }

  const hideNav = oct2026 && pathname === "/";

  return (
    <>
      {!hideNav && <NavBar />}
      <Routes>
        <Route path="/" element={oct2026 ? <GoHome /> : <Home />} />
        <Route path="/Experiences" element={<Experiences />} />
        <Route path="/Projects" element={<Projects />} />
        <Route path="/Art" element={<Art />} />
        <Route path="/Photography" element={<Photography />} />
        <Route path="/photography/:countryId" element={<CountryGallery />} />
      </Routes>
    </>
  );
}

function App() {
  useEffect(() => {
    // Preload gallery images
    const galleryImages = [
      covid, metoo, prize,
      teeth1, teeth2, teeth3, fight, man,
      corn, diana1, diana2, grandparents, kids, twoGirls, parents
    ];

    galleryImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
      <Router>
        <AppRoutes />
      </Router>
  );
}

export default App;
